'use client'

import { IFeedRecord } from '@/interfaces/IFeedRecord'
import Tooltip from '@mui/material/Tooltip'
import NextLink from 'next/link'
import IconButton from '@mui/material/IconButton'
import NextImage from 'next/image'
import imageService from '@/modules/imageService/client'
import Avatar from '@mui/material/Avatar'
import PostMenu from '@/components/display/PostMenu'
import styles from './AvatarBar.module.scss'
import timestampService from '@/modules/timestampService'
import clientGetLocale from '@/modules/langService/clientGetLocale'

interface AvatarBarProps {
  record: IFeedRecord
  // eslint-disable-next-line no-unused-vars
  openReportDialog: (id: string) => void
}

function AvatarBar ( { record, openReportDialog }: AvatarBarProps) {
  const locale = clientGetLocale()
  const date = record.timedReleaseAt || record.publishedAt

  return (
    <div className={styles.wrapper}>
      <div>
        <Tooltip title={record.createdBy}>
          <NextLink href={`/${record.createdBy}/profile`} style={{ display: 'flex' }}>
            <IconButton
              size="small"
              sx={{ mr: '0.5rem', padding: 0 }}
              className={styles.avatarButton}
            >
              {record.createdByAvatar &&
                <NextImage
                  src={imageService.postImageURL('avatars', record.createdByAvatar)}
                  alt='Avatar'
                  width={25}
                  height={25}
                  style={{
                    borderRadius: '50%',
                    border: '1px solid rgba(0, 0, 0, 0.15)'
                  }}
                />
              }
              {!record.createdByAvatar &&
                <Avatar sx={{ width: 25, height: 25 }}>
                  {record.createdBy ? record.createdBy[0].toUpperCase() : '?'}
                </Avatar>
              }
            </IconButton>
            <div className={styles.username}>
              {record.createdBy}
            </div>
          </NextLink>
        </Tooltip>
      </div>
      <div className={styles.timestampWrapper}>
        <div className={styles.dot}>•</div>
        <div>
          {timestampService.formatRelativeOrFullDate(date, locale)}
        </div>
      </div>
      <div className={styles.menuDropdown}>
        <PostMenu
          editor={false}
          postId={record.id}
          slug={record.slug}
          pageUrl={`${process.env.NEXT_HOST || 'https://steppingstonesintl.com'}/${record.slug}`}
          handleReportOption={(id) => {
            openReportDialog(id)
          }}
        />
      </div>
    </div>
  )
}

export default AvatarBar
